import {
  WeedMaps,
  WeedMapStatus,
  WeedMapStatusResponse
} from "@/interfaces/weedMaps";
import { ErrorApiResponse, messagesService } from "@/services/messages.service";
import { AxiosResponse } from "axios";
import axios from "axios";
import Cookie from "js-cookie";
import HttpService from "./http.service";

class WeedMapsIntegrationService extends HttpService {
  public loading: boolean | undefined;

  /*
   * Enables a location integration with Weedmaps service.
   * @param model: WeedMaps
   * @returns Promise<ClientIntegration | void>
   */
  public enableIntegration(model: WeedMaps) {
    const url = `${
      process.env.VUE_APP_WEEDMAPS_BASE_URL
    }/oauth/authorize?client_id=${
      process.env.VUE_APP_WEEDMAPS_CLIENT_ID
    }&redirect_uri=${process.env.VUE_APP_CORE_FRONTEND}${
      process.env.VUE_APP_WEEDMAPS_REDIRECT_URL
    }&response_type=code&scope=menu_items`;
    Cookie.set("weedmaps_location_id", String(model.biotrack_location_id), {
      domain: `${process.env.VUE_APP_COOKIE_DOMAIN}`
    });
    Cookie.set("weedmaps_listing_wmid", model.listing_wmid, {
      domain: `${process.env.VUE_APP_COOKIE_DOMAIN}`
    });

    location.replace(url);
  }

  /*
   * Token obtaining and code authorization
   * @param model: weedmapsCode
   */

  public async weedmapsCode(weedmapsCode: string): Promise<any> {
    try {
      const instance = axios.create();
      const payload = {
        client_id: process.env.VUE_APP_WEEDMAPS_CLIENT_ID,
        client_secret: process.env.VUE_APP_WEEDMAPS_CLIENT_SECRET,
        code: weedmapsCode,
        grant_type: "authorization_code",
        redirect_uri:
          process.env.VUE_APP_CORE_FRONTEND +
          process.env.VUE_APP_WEEDMAPS_REDIRECT_URL,
        "user-agent": process.env.VUE_APP_WEEDMAPS_USER_AGENT
      };
      const response: AxiosResponse = await instance.post(
        `${process.env.VUE_APP_WEEDMAPS_BASE_URL_TOKEN}/auth/token`,
        payload
      );
      return response.data.data || response.data;
    } catch (e) {
      messagesService.renderWMErrorMessage(e);
    }
  }

  /*
   * obtaining and token for Catalog creation
   * @param model: responsetoken
   */

  public async createCatalog(
    responsetoken: {
      access_token: string;
      expires_in: string;
      refresh_token: string;
    },
    timezonezone: string
  ): Promise<WeedMaps | null> {
    try {
      const payload = {
        biotrack_location_id: Cookie.get("weedmaps_location_id"),
        listing_wmid: Cookie.get("weedmaps_listing_wmid"),
        access_token: responsetoken.access_token,
        refresh_token: responsetoken.refresh_token,
        expires_in: responsetoken.expires_in,
        client_id: process.env.VUE_APP_WEEDMAPS_CLIENT_ID,
        client_secret: process.env.VUE_APP_WEEDMAPS_CLIENT_SECRET,
        timezone: timezonezone,
        is_integration_active: true
      };
      this.uri = `${process.env.VUE_APP_YODA_BASE_URL}/api/v1/setup/token`;
      const response = await super.post(payload);
      this.uri = `${
        process.env.VUE_APP_BASE_URL_DISPENSARY
      }/integrations/weed_maps/enable/${payload.biotrack_location_id}`;
      await super.patch();
      return response.data;
    } catch (e) {
      const errorResp: ErrorApiResponse = e.response && e.response.data;
      if (errorResp.error && errorResp.error.message) {
        delete errorResp.error.errors;
      }
      messagesService.renderErrorMessage(e);
      return null;
    }
  }

  /*
   * disable integration with Weedmaps
   * @param model: locationId
   */

  public async disableIntegration(locationId: number): Promise<any> {
    try {
      const payload = {
        biotrack_location_id: locationId.toString(),
        is_integration_active: false
      };
      this.uri = `${process.env.VUE_APP_YODA_BASE_URL}/api/v1/setup/token`;
      const response = await super.post(payload);
      this.uri = `${
        process.env.VUE_APP_BASE_URL_DISPENSARY
      }/integrations/weed_maps/disable/${locationId}`;
      await super.patch();
      messagesService.renderSuccessMessage("weedmaps.location_disabled");
      return response.data;
    } catch (e) {
      messagesService.renderWMErrorMessage(e);
    }
    return (this.loading = false);
  }

  /*
   * Locations for integration with weedmaps are obtained
   * @param model: locationId
   * @returns Promise<WeedMapStatusResponse| void>
   */
  public async checkIntegrationStatus(): Promise<any | null> {
    this.uri = `${process.env.VUE_APP_YODA_BASE_URL}/api/v1/locations/all`;
    try {
      /*const headers = {
        Location: id
      };*/
      const response: WeedMapStatus = await super.get();
      return response.data;
    } catch (e) {
      return null;
    }
  }

  public async connect(): Promise<any | null> {
    this.uri = `${process.env.VUE_APP_YODA_BASE_URL}/weedmaps/connect`;
    try {
      const response = await super.get();
      messagesService.renderSuccessMessage("weedmaps.message");
      return response.data;
    } catch (e) {
      messagesService.renderWMErrorMessage(e);
    }
  }
}
export const weedMapsIntegrationService = new WeedMapsIntegrationService();
